import { varIs, varIsIn } from "common/var";
import { ReactComponent as HomeIcon } from "assets/icons/nueva/icons/dashboard-nueva.svg";
import { ReactComponent as AccountIcon } from "assets/icons/nueva/icons/account-n.svg";
import { ReactComponent as WalletIcon } from "assets/icons/nueva/icons/wallet.svg";
import { ReactComponent as SubscriptionsIcon } from "assets/icons/nueva/icons/subscription.svg";
import { ReactComponent as WebsitesIcon } from "assets/icons/nueva/icons/globe.svg";
import { ReactComponent as TeamIcon } from "assets/icons/nueva/icons/team-n.svg";
import { ReactComponent as ContactManagerIcon } from "assets/icons/nueva/icons/contact.svg";
import { ReactComponent as EarningsIcon } from "assets/icons/nueva/icons/earnings.svg";
import { ReactComponent as ReportsIcon } from "assets/icons/nueva/icons/reports.svg";
import { ReactComponent as ResourcesIcon } from "assets/icons/nueva/icons/resources.svg";
import { ReactComponent as SupportIcon } from "assets/icons/nueva/icons/support-n.svg";
import { ReactComponent as TravelIcon } from "assets/icons/nueva/icons/travel.svg";
import { ReactComponent as ShopIcon } from "assets/icons/nueva/icons/shop.svg";
import { ReactComponent as EventIcon } from "assets/icons/nueva/icons/tickets.svg";

export const getMenus = (myUser, isMobile = false) => {
  let menus = [];
  let menu = null;
  let submenus = [];
  let submenu = null;
  if (
    varIsIn("user.status", myUser.status, [
      "active",
      "inactive",
      "hold_temp",
      "purged",
    ]) &&
    !varIs("user.taxStatus", myUser.tax_status, "requested") &&
    !varIs("user.verificationStatus", myUser.verification_status, "requested")
  ) {
    // single
    if (varIs("user.type", myUser.type, "affiliate")) {
      menu = {
        label: "Dashboard",
        route: "/",
        icon: <HomeIcon />,
      };
      menus.push(menu);
    }

    // submenu
    menu = {
      label: "Account",
      route: "/account",
      icon: <AccountIcon />,
    };
    submenus = [];
    submenu = {
      label: "Settings",
      route: "/my_account/setting",
    };
    submenus.push(submenu);
    submenu = {
      label: "Order History",
      route: "/my_account/order_history",
    };
    submenus.push(submenu);
    menu["submenus"] = submenus;
    menus.push(menu);

    menu = {
      label: "Events",
      route: "/event_menu",
      icon: <EventIcon />
    };
    submenus = [];
    submenu = {
      label: "My Tickets",
      route: "/ticket/my_ticket"
    };
    submenus.push(submenu);
    submenu = {
      label: "Buy Tickets",
      route: "/ticket/buy_ticket"
    };
    submenus.push(submenu);
    submenu = {
      label: "Downline Ticket Report",
      route: "/report/ticket_report"
    };
    submenus.push(submenu);
   
    menu["submenus"] = submenus;
    menus.push(menu);

    if (varIs("user.type", myUser.type, "affiliate")) {
      //
      menu = {
        label: "Wallet",
        route: "/my_account",
        icon: <WalletIcon />,
      };
      submenus = [];
      submenu = {
        label: "Digital Wallet",
        route: "/my_account/credit_wallet",
      };
      submenus.push(submenu);
      submenu = {
        label: "Gift Wallet",
        route: "/my_account/loyalty_wallet",
      };
      submenus.push(submenu);
      menu["submenus"] = submenus;
      menus.push(menu);
    }
    if (varIs("user.type", myUser.type, "preferred")) {
      menu = {
        label: "Wallet",
        route: "/my_account",
        icon: <WalletIcon />,
      };
      submenus = [];
      submenu = {
        label: "Gift Wallet",
        route: "/my_account/loyalty_wallet",
      };
      submenus.push(submenu);
      menu["submenus"] = submenus;
      menus.push(menu);
    }
    menu = {
      label: "Subscription",
      route: "/my_account/subscription",
      icon: <SubscriptionsIcon />,
    };
    menus.push(menu);

    menu = {
      label: "Travel",
      route: "/travel",
      icon: <TravelIcon />,
    };
    submenus = [];
    submenu = {
      label: "Nueva Travel",
      route: "/travel/nv_travel",
    };
    submenus.push(submenu);
    submenu = {
      label: "Nueva Deals",
      route: "/travel/ad_sso"
    };
    submenus.push(submenu);
    if (varIs("user.type", myUser.type, "affiliate")) {
      submenu = {
        label: "Travel Leaderboard",
        route: "/travel/nv_travel_leaderboard",
      };
      submenus.push(submenu);
    }
    menu["submenus"] = submenus;
    menus.push(menu);

    menu = {
      label: "Websites",
      route: "/websites",
      icon: <WebsitesIcon />,
    };
    submenus = [];
    submenu = {
      label: "Custom website",
      route: "/my_website/custom_website",
    };
    submenus.push(submenu);
    submenu = {
      label: "Replicated websites",
      route: "/my_website/replicated",
    };
    submenus.push(submenu);
    submenu = {
      label: "Shareable Carts",
      route: "/my_website/share_cart"
    };
    submenus.push(submenu);
    // submenu = {
    //   label: "Analytic Studio",
    //   route: "",
    // };
    // submenus.push(submenu);
    menu["submenus"] = submenus;
    menus.push(menu);

    if (varIs("user.type", myUser.type, "affiliate")) {
      // websites

      // teams

      menu = {
        label: "Teams",
        route: "/teams",
        icon: <TeamIcon />,
      };
      submenus = [];
      submenu = {
        label: "Enroller List",
        route: "/my_team/unilevel_list",
      };
      submenus.push(submenu);
      submenu = {
        label: "Enroller Tree",
        route: "/my_team/unilevel_tree",
      };
      submenus.push(submenu);
      submenu = {
        label: "Placement List",
        route: "/my_team/placement_list",
      };
      submenus.push(submenu);
      submenu = {
        label: "Placement Tree",
        route: "/my_team/placement_tree",
      };
      submenus.push(submenu);
      submenu = {
        label: "Holding Tank",
        route: "/my_team/holding_tank",
      };
      submenus.push(submenu);
      menu["submenus"] = submenus;
      menus.push(menu);

      menu = {
        label: "Contact Manager",
        route: "/contact_manager",
        icon: <ContactManagerIcon />,
      };
      menus.push(menu);

      // earnings
      menu = {
        label: "Earnings",
        route: "/earning",
        icon: <EarningsIcon />,
      };
      submenus = [];
      submenu = {
        label: "Earning History",
        route: "/earning",
      };
      submenus.push(submenu);
      submenu = {
        label: "Payout Option",
        route: "/my_account/payment_option",
      };
      submenus.push(submenu);
      menu["submenus"] = submenus;
      menus.push(menu);

      // reports
      menu = {
        label: "Reports",
        route: "/report",
        icon: <ReportsIcon />,
      };
      submenus = [];
      submenu = {
        label: "Promoter Rank Tracker",
        route: "/report/rank_tracker",
      };
      submenus.push(submenu);
      submenu = {
        label: "Builder Rank Tracker",
        route: "/report/builder_rank_tracker",
      };
      submenus.push(submenu);
      submenu = {
        label: "Rank History",
        route: "/report/rank_history",
      };
      submenus.push(submenu);
      submenu = {
        label: "Current Promoter Rank Report",
        route: "/report/current_promoter_rank",
      };
      submenus.push(submenu);
      submenu = {
        label: "Current Builder Rank Report",
        route: "/report/current_builder_rank",
      };
      submenus.push(submenu);
      submenu = {
        label: "Subscription Report",
        route: "/report/subscription_report",
      };
      submenus.push(submenu);
      submenu = {
        label: "Abandon Cart",
        route: "/report/abandon_cart",
      };
      submenus.push(submenu);
      submenu = {
        label: "Recruiter Leaderboard",
        route: "/report/leaderboard",
      };
      submenus.push(submenu);

      submenu = {
        label: "Customer Pod Report",
        route: "/report/customer_pod",
      };
      submenus.push(submenu);
      submenu = {
        label: "New Customer Leaderboard",
        route: "/report/customer_leaderboard",
      };
      submenus.push(submenu);
      submenu = {
        label: "Active Customer Leaderboard",
        route: "/report/active_customer_leaderboard",
      };
      submenus.push(submenu);
      submenu = {
        label: "Customer Referal Leaderboard",
        route: "/report/customer_referal_leaderboard",
      };
      submenus.push(submenu);
      submenu = {
        label: "New Promoter Rank Ups",
        route: "/report/new_promoter_rank_up",
      };
      submenus.push(submenu);
      submenu = {
        label: "New Builder Rank Ups",
        route: "/report/new_builder_rank_up",
      };
      submenus.push(submenu);
      submenu = {
        label: "Gift Wallet Redeem Report",
        route: "/report/gw_report"
      };
      submenus.push(submenu);
      submenu = {
        label: "Elevate Customer Leaderboard",
        route: "/report/elevate_customer_leaderboard",
      };
      submenus.push(submenu);
      menu["submenus"] = submenus;
      submenu = {
        label: "Elevate SM Leaderboard",
        route: "/report/elevate_sm_leaderboard",
      };
      submenus.push(submenu);
      menus.push(menu);

      menu = {
        label: "Resources",
        route: "/tool/resources",
        icon: <ResourcesIcon />,
      };
      menus.push(menu);
    }
    menu = {
      label: "Shop Nueva",
      route: "/shop_nueva",
      icon: <ShopIcon />,
    };
    menus.push(menu);
    
    if (myUser.username !== "merchant_nueva") {
      menu = {
        label: "Shop BodynBeauty",
        route: "/shop_bodynbeauty",
        icon: <ShopIcon />,
      };
      menus.push(menu);
    }

    menu = {
      label: "Support",
      route: "/support",
      icon: <SupportIcon />,
    };
    menus.push(menu);
    if (
      varIs("user.type", myUser.type, "preferred") &&
      new Date().getDate() > 6
    ) {
      menu = {
        label: "Upgrade Account",
        route: "/upgrade_account",
        icon: <TeamIcon />,
      };
      menus.push(menu);
    }
  }
  if (
    varIs("user.type", myUser.type, "affiliate") &&
    varIsIn("user.status", myUser.status, [
      "active",
      "inactive",
      "hold_temp",
    ]) &&
    varIs("user.taxStatus", myUser.tax_status, "requested")
  ) {
    // menu = {
    //   label: "Tax Form",
    //   route: "/tax_form",
    //   icon: <TaxIcon />,
    // };
    // menus.push(menu);
  }
  if (
    varIs("user.type", myUser.type, "affiliate") &&
    varIsIn("user.status", myUser.status, [
      "active",
      "inactive",
      "hold_temp",
    ]) &&
    varIs("user.verificationStatus", myUser.verification_status, "requested")
  ) {
    // menu = {
    //   label: "Verification",
    //   route: "/verification",
    //   icon: <IdcardIcon />,
    // };
    // menus.push(menu);
  }

  return menus;
};

export const hasPageAccess = (pathname, myUser, sudoName) => {
  const menus = getMenus(myUser);
  let isAble = false;
  menus.forEach((el) => {
    if (el.route === pathname) {
      isAble = true;
    }
    if (el.submenus && el.submenus.length > 0) {
      el.submenus.forEach((el2) => {
        if (el2.route === pathname) {
          isAble = true;
        }
      });
    }
  });
  // --- external urls
  if (
    varIs("user.type", myUser.type, "affiliate") &&
    varIsIn("user.status", myUser.status, [
      "active",
      "inactive",
      "hold_temp",
    ]) &&
    !varIs("user.taxStatus", myUser.tax_status, "requested") &&
    !varIs(
      "user.verificationStatus",
      myUser.verification_status,
      "requested"
    ) &&
    [
      "/my_account/order_receipt",
      "/publisher",
      "/notification",
      "/checkout",
      "/viewer",
      "/report/commission_calculator",
      "/hlt_access",
      "/my_account/savvi_buy",
    ].indexOf(pathname) >= 0
  ) {
    isAble = true;
  }

  if (
    varIs("user.type", myUser.type, "preferred") &&
    varIsIn("user.status", myUser.status, [
      "active",
      "inactive",
      "hold_temp",
    ]) &&
    !varIs("user.taxStatus", myUser.tax_status, "requested") &&
    !varIs(
      "user.verificationStatus",
      myUser.verification_status,
      "requested"
    ) &&
    [
      "/checkout",
      "/notification",
    ].indexOf(pathname) >= 0
  ) {
    isAble = true;
  }

  if (pathname.includes("/training/watchList/")) {
    isAble = true;
  }

  return isAble;
};

export const getPageTitle = (pathname, myUser) => {
  let pageTitle = null;
  const menus = getMenus(myUser);
  menus.forEach((menu0) => {
    if (menu0.route === pathname) {
      pageTitle = menu0.label;
    }
    if (menu0.submenus) {
      menu0.submenus.forEach((submenu0) => {
        if (submenu0.route === pathname) {
          pageTitle = submenu0.label;
        }
      });
    }
  });

  return pageTitle;
};
